export const REQUEST_DETAILS_SUMMARY_BOX_CONFIRMATION_DESCRIPTIONS: Record<string, string> = {
  complete: `Reminder: make sure all final documents have been sent to their recipients before completing this request.`,
  cancel: `Are you sure you want to cancel this request? This action cannot be undone.`,
  paid: `Are you sure you want to mark this request as paid?`,
  externalPayCancel: `Please confirm payment for this request has been refunded to the patient.`,
  default: `Are you sure you want to mark this request as submitted? Please ensure all required documents and the invoice have been sent to the 3rd party.`,
};
